import { RefObject, useEffect } from "react";

interface iOutsideClick {
    ref?: RefObject<HTMLElement>;
    isDisabled?: boolean;
    callback: () => void;
    ignoreNodesIds?: string[];
    capture?: boolean;
}

const useOutsideClick = ({
    ref,
    callback,
    isDisabled = false,
    ignoreNodesIds = [],
    capture = true,
}: iOutsideClick) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                ref?.current &&
                !ref.current.contains(event.target as Node) &&
                !ignoreNodesIds.some((id) => {
                    const element = document.getElementById(id);
                    return element === event.target || element?.contains(event.target as Node);
                })
            ) {
                callback();
            }
        };
        if (!isDisabled) {
            document.addEventListener("mousedown", handleClickOutside, capture);
        } else {
            document.removeEventListener("mousedown", handleClickOutside, capture);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside, capture);
        };
    }, [callback, ref, isDisabled, ignoreNodesIds, capture]);
};

export default useOutsideClick;
